/**
 * Format announcement updatedAt (Unix seconds) for list display: YYYY-MM-DD HH:mm
 */
export function formatAnnouncementDate(unixSec: number): string {
  if (!unixSec || !Number.isFinite(unixSec)) return "—";

  const d = new Date(unixSec * 1000);
  const pad = (n: number) => String(n).padStart(2, "0");
  const date = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  const time = `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  return `${date} ${time}`;
}
